const paramsList = {
  page: { name: 'page', type: 'string' },
  sort: { name: 'sort', type: 'string' },
  q: { name: 'q', type: 'query' },
  company_id: { name: 'filters[company_id][]', type: 'arraySingle', eventParam: 'company_name' },
  category_ids: { name: 'filters[category_ids][]', type: 'array', eventParam: 'category_names' },
  industry_ids: { name: 'filters[industry_ids][]', type: 'array', eventParam: 'industry_names' },
  work_type_ids: { name: 'filters[work_type_ids][]', type: 'array', eventParam: 'work_type_names' },
  entry_level_ids: { name: 'filters[entry_level_ids][]', type: 'array', eventParam: 'entry_level_names' },
  job_language_ids: { name: 'filters[job_language_ids][]', type: 'array', eventParam: 'job_language_names' },
  number_employees_group_ids: { name: 'filters[number_employees_group_ids][]', type: 'array', eventParam: 'number_employees_group_names' },
  region_ids: { name: 'filters[region_ids][]', type: 'array', eventParam: 'region_names' },
  place_id: { name: 'filters[place_id][]', type: 'arraySingle', eventParam: 'place_name' },
  distance: { name: 'filters[distance][]', type: 'arraySingle' }
};

export default paramsList;
